import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SegmentInformationDto } from "../dto/segment.information.dto";

@Injectable({
    providedIn: 'root'
})
export class SegmentSubjectService {
    private segmentSubject: BehaviorSubject<SegmentInformationDto | null> = new BehaviorSubject<SegmentInformationDto | null>(null);
    public segmentDetail$: Observable<SegmentInformationDto | null> = this.segmentSubject.asObservable();

    /**
     * Actualiza el segmento seleccionado en el BehaviorSubject.
     * @param segment El segmento seleccionado por el usuario.
     */
    public updateSelectedSegment(segment: SegmentInformationDto): void {
        if (this.segmentSubject.value !== segment) {
            this.segmentSubject.next(segment);
            console.log('Segmento seleccionado:', segment);
        }
    }

    /**
     * Obtiene el segmento seleccionado actualmente.
     * @returns El segmento seleccionado actual.
     */
    public getSelectedSegment(): SegmentInformationDto | null {
        return this.segmentSubject.value;
    }

    /** Limpia el segmento seleccionado (publicación nueva). */
    public clearSelectedSegment(): void {
        this.segmentSubject.next(null);
    }
}
